import { useParams, Link, useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { categories } from '@/mocks/categories';
import { getComicsByCategory } from '@/mocks/comics';

const catImages: Record<string, string> = {
  'cat-1': 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20illustration%20couple%20holding%20hands%20under%20cherry%20blossom%20tree%20soft%20pink%20warm%20lighting%20dreamy%20atmosphere%20pastel%20color%20palette%20gentle%20emotional%20scene%20elegant%20manhwa%20art%20style%20clean%20background&width=1800&height=600&seq=cat-romance-01&orientation=landscape',
  'cat-2': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20dynamic%20fight%20scene%20martial%20arts%20intense%20battle%20pose%20dramatic%20lighting%20fiery%20orange%20red%20background%20powerful%20energy%20explosion%20effects%20manhwa%20art%20style%20epic%20composition&width=1800&height=600&seq=cat-action-01&orientation=landscape',
  'cat-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20dark%20alleyway%20mysterious%20shadow%20figure%20dim%20streetlight%20foggy%20atmosphere%20cold%20gray%20tones%20suspenseful%20noir%20style%20manhwa%20art%20tense%20mood%20clean%20composition&width=1800&height=600&seq=cat-thriller-01&orientation=landscape',
  'cat-4': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20magical%20kingdom%20castle%20floating%20islands%20glowing%20crystals%20mystical%20forest%20warm%20golden%20emerald%20light%20enchanting%20atmosphere%20manhwa%20art%20style%20lush%20detailed%20environment&width=1800&height=600&seq=cat-fantasy-01&orientation=landscape',
  'cat-5': 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20funny%20school%20life%20chibi%20characters%20laughing%20together%20bright%20sunny%20classroom%20yellow%20cheerful%20color%20palette%20playful%20vibrant%20manhwa%20art%20style%20happy%20warm%20atmosphere&width=1800&height=600&seq=cat-comedy-01&orientation=landscape',
  'cat-6': 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cityscape%20night%20view%20lonely%20office%20worker%20by%20window%20rainy%20mood%20warm%20apartment%20lights%20reflective%20atmosphere%20muted%20teal%20gray%20tones%20manhwa%20art%20style%20emotional%20realistic&width=1800&height=600&seq=cat-drama-01&orientation=landscape',
  'cat-7': 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20haunted%20mansion%20dark%20corridor%20flickering%20candle%20light%20eerie%20shadow%20crimson%20accents%20gothic%20atmosphere%20manhwa%20art%20style%20chilling%20mood%20deep%20shadows%20clean%20composition&width=1800&height=600&seq=cat-horror-01&orientation=landscape',
  'cat-8': 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20ancient%20palace%20courtyard%20traditional%20hanbok%20clothing%20elegant%20noble%20figure%20soft%20golden%20sunset%20light%20cherry%20blossom%20petals%20classic%20manhwa%20art%20style%20serene%20atmosphere&width=1800&height=600&seq=cat-historical-01&orientation=landscape',
  'cat-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cozy%20cafe%20interior%20cat%20sleeping%20on%20windowsill%20warm%20sunlight%20steaming%20coffee%20cup%20gentle%20cream%20beige%20tones%20peaceful%20slice%20of%20life%20manhwa%20art%20style%20soft%20atmosphere&width=1800&height=600&seq=cat-healing-01&orientation=landscape',
};

const coverImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20handsome%20male%20protagonist%20with%20glowing%20spiritual%20energy%20surrounding%20him%20modern%20city%20background%20at%20night%20dramatic%20pose%20golden%20and%20jade%20green%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-01&orientation=portrait',
  'comic-2': 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20elegant%20CEO%20man%20in%20black%20suit%20and%20beautiful%20woman%20in%20white%20dress%20rose%20petals%20scattered%20romantic%20atmosphere%20pink%20cream%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20thriller%20webtoon%20cover%20art%20detective%20figure%20in%20dark%20trench%20coat%20standing%20in%20rainy%20alley%20neon%20reflections%20mysterious%20silhouette%20deep%20teal%20and%20crimson%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-03&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Korean%20action%20webtoon%20cover%20art%20martial%20artist%20with%20long%20sword%20dramatic%20battle%20stance%20energy%20waves%20surrounding%20fiery%20orange%20and%20gold%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-04&orientation=portrait',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20webtoon%20cover%20art%20magic%20academy%20student%20casting%20spell%20with%20magic%20circle%20floating%20books%20purple%20and%20gold%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-05&orientation=portrait',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20comedy%20webtoon%20cover%20art%20group%20of%20high%20school%20students%20laughing%20together%20in%20classroom%20bright%20sunny%20yellow%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-06&orientation=portrait',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20historical%20webtoon%20cover%20art%20beautiful%20woman%20in%20traditional%20hanbok%20standing%20in%20ancient%20palace%20garden%20soft%20autumn%20leaves%20golden%20beige%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-07&orientation=portrait',
  'comic-8': 'https://readdy.ai/api/search-image?query=Korean%20horror%20webtoon%20cover%20art%20exorcist%20holding%20talisman%20against%20dark%20spirit%20shadow%20in%20modern%20apartment%20eerie%20green%20glow%20dark%20atmosphere%20clean%20simple%20background&width=400&height=560&seq=comic-cover-08&orientation=portrait',
  'comic-9': 'https://readdy.ai/api/search-image?query=Korean%20healing%20webtoon%20cover%20art%20cozy%20cafe%20barista%20smiling%20behind%20counter%20steaming%20coffee%20warm%20sunlight%20through%20window%20cream%20beige%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
  'comic-10': 'https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20art%20confident%20businesswoman%20in%20office%20attire%20looking%20out%20skyscraper%20window%20city%20skyline%20sunset%20warm%20muted%20teal%20color%20scheme%20clean%20simple%20background&width=400&height=560&seq=comic-cover-10&orientation=portrait',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const category = categories.find((c) => c.slug === slug);
  const categoryComics = slug ? getComicsByCategory(slug) : [];

  if (!category) {
    return (
      <>
        <SEO title="分类未找到 - 韩漫之家" description="抱歉，您访问的分类页面不存在。" keywords="韩漫之家" />
        <Navbar />
        <main className="pt-16 min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-3xl font-bold text-foreground-950">分类未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const catName = category.name;
  const catTitle = `${catName}韩漫 - ${catName}韩国漫画下拉式阅读 - 韩漫之家`;
  const catDesc = `韩漫之家${catName}分类为您精选${category.count}部${catName}题材的免费韩国漫画，高清画质下拉式在线阅读，每日更新，尽在韩漫之家。`;

  const breadcrumbLD = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': [
      { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'http://dnchemical.com/' },
      { '@type': 'ListItem', 'position': 2, 'name': catName, 'item': `http://dnchemical.com/category/${slug}` },
    ],
  };

  const webPageLD = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': catTitle,
    'description': catDesc,
    'url': `http://dnchemical.com/category/${slug}`,
    'isPartOf': { '@type': 'WebSite', 'name': '韩漫之家', 'url': 'http://dnchemical.com/' },
  };

  return (
    <>
      <SEO
        title={catTitle}
        description={catDesc}
        keywords={`${catName},免费韩漫,韩国漫画,韩漫之家`}
        canonicalUrl={`http://dnchemical.com/category/${slug}`}
      />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbLD) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageLD) }} />
      <Navbar />
      <main>
        <section className="relative pt-16">
          <div className="bg-secondary-50 pt-8 md:pt-12 pb-16 md:pb-20">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-6" aria-label="breadcrumb">
                <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                <span>/</span>
                <span className="text-foreground-600">{category.name}</span>
              </nav>

              <div className="flex flex-col lg:flex-row gap-10 items-start">
                <div className="flex-1">
                  <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
                    分类大全
                  </span>
                  <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
                    {category.name}
                    <span className="block text-2xl md:text-3xl text-foreground-400 mt-2">精选韩漫</span>
                  </h1>
                  <p className="mt-4 text-sm text-foreground-500 max-w-lg leading-relaxed">
                    {category.description}
                  </p>
                  <div className="mt-8 flex flex-wrap gap-4">
                    {['恋爱甜宠', '热血动作', '惊悚悬疑', '奇幻冒险'].map((tag) => (
                      <span key={tag} className="text-sm font-medium text-foreground-600 whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-lg overflow-hidden">
                    <img
                      src={catImages[category.id]}
                      alt={category.name}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>

              <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-6">
                {[
                  { value: `${category.count}+`, label: '精选漫画' },
                  { value: '5000+', label: '已完结' },
                  { value: '每日300+', label: '更新' },
                  { value: '100%', label: '高清' },
                ].map((stat) => (
                  <div key={stat.label} className="text-center">
                    <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">
                      {stat.value}
                    </div>
                    <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-8 md:py-10 bg-background-50 border-b border-background-200 sticky top-16 z-30">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-3 overflow-x-auto pb-1 scrollbar-hide">
              <span className="text-xs font-medium text-foreground-400 whitespace-nowrap flex-shrink-0">全部分类：</span>
              {categories.map((cat) => {
                const isActive = cat.slug === slug;
                return (
                  <button
                    key={cat.id}
                    onClick={() => navigate(`/category/${cat.slug}`)}
                    className={`flex-shrink-0 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                      isActive
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                    }`}
                  >
                    {cat.name}
                  </button>
                );
              })}
            </div>
          </div>
        </section>

        <section className="py-16 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10">
              {category.name} · 漫画列表
            </h2>

            {categoryComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5">
                {categoryComics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/article/${comic.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                      <img
                        src={coverImages[comic.id]}
                        alt={comic.title}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute top-2 left-2">
                        <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                          comic.status === '连载中' ? 'bg-accent-500 text-background-50' : 'bg-secondary-500 text-background-50'
                        }`}>
                          {comic.status}
                        </span>
                      </div>
                    </div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                      {comic.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1 text-xs text-foreground-400">
                      <span className="flex items-center gap-0.5">
                        <i className="ri-star-fill text-accent-400 text-xs"></i> {comic.rating}
                      </span>
                      <span>{comic.chapters.length}章</span>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-400">该分类暂无漫画，敬请期待</p>
              </div>
            )}
          </div>
        </section>

        <section className="relative py-24 md:py-32 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20epic%20fantasy%20world%20colorful%20magical%20landscape%20floating%20books%20sparkles%20golden%20light%20rays%20dreamy%20atmosphere%20manhwa%20art%20style&width=1800&height=800&seq=cta-category&orientation=landscape"
              alt="韩漫之家 - 更多漫画"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/50"></div>
          </div>
          <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">找不到想看的漫画？</h2>
            <p className="mt-3 text-sm md:text-base text-background-50/70">我们有超过10万部漫画资源，搜索试试看吧</p>
            <div className="mt-6 max-w-md mx-auto relative">
              <input
                type="text"
                placeholder="搜索漫画名称、作者..."
                className="w-full px-5 py-3 pl-12 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 placeholder:text-background-50/50 border border-background-50/20 focus:border-background-50/50 focus:outline-none text-sm"
              />
              <span className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                <i className="ri-search-line text-background-50/60"></i>
              </span>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}